const initialState = () => {
  return {
    unsubscribeInfo: null,
    subscriptionInfo: null,
    createSubscription: null,
    errors: {
      subscriptionError: {
        hasError: null,
        error: []
      },
      unsubscribeError: {
        hasError: null,
        error: []
      },
      applicationError: {
        hasError: null,
        error: []
      },
      timeoutError: {
        hasError: null,
        error: []
      },
      createSubscriptionError: {
        hasError: null,
        error: []
      },
      maintenanceError: {
        hasError: null,
        error: []
      }
    }
  };
};

export default initialState;
